import axios from "axios";
import {BASE_URL} from "../config";
import {SWAGGER_BASE_URL} from "../config";
import {useNavigate} from "react-router-dom";

/* API */
export const axiosAnonClient = axios.create({
  baseURL: `${SWAGGER_BASE_URL}`,
  headers: {
    "X-Custom-Header": "foobar",
  },
  timeout: 10000,
});

export const axiosClient = axios.create({
  baseURL: `${SWAGGER_BASE_URL}`,
  headers: {
    "X-Custom-Header": "foobar",
    // "Authorization": `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`
    "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`
  },
  timeout: 10000,
});

export const axiosClientFormData = axios.create({
  baseURL: `${SWAGGER_BASE_URL}`,
//  headers: {
//    "X-Custom-Header": "foobar",
//    "Content-Type": "multipart/form-data",
//    // "Authorization": `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`
//    "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`
//  },
  timeout: 10000,
});

// 20230112 add
export const axiosClientJsonData = axios.create({
  baseURL: `${SWAGGER_BASE_URL}`,
  //headers: {
  //	"X-Custom-Header": "foobar",
  //	"Content-Type": "multipart/form-data",
  //	// "Authorization": `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`
  //	"Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`
  //},
  timeout: 10000,
});

const apiAnonClientPost = (url, requestBody) => {
  let ret;
  ret = axiosAnonClient.post(url, requestBody);
  return ret;
}

const apiClientPost = (url, requestBody) => {
  let ret;
  ret = axiosClient.post(url, requestBody);
  console.log(ret);
  return ret;
}

const apiClientPostFormData = (url, formData) => {
  let ret;
  ret = axiosClientFormData.post(url, formData, {
    headers: {
      "X-Custom-Header": "foobar",
      "Content-Type": "multipart/form-data",
      // "Authorization": `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`
      "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`
    },
  });
  return ret;
}

// 20230112 add
const apiClientPostJsonData = (url, data) => {
  console.log(`sessionStorage.getItem() :: ${sessionStorage.getItem('ACCESS_TOKEN')}`);
  let ret;
  ret = axiosClientJsonData.post(url, data, {
    headers: {
      "X-Custom-Header": "foobar",
      "Content-Type": "application/json",
      // "Authorization": `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`
      "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`
    },
  });
  return ret;
}

const urlAddParam = (name, value, isFirstParam = false) => {

  let urlParam = ''
  let newName = name;
  let sendVal = value

  if (sendVal == undefined || sendVal == null) {
    console.log(`Ignore param: ${name}`);
    sendVal = '';
  }

  if (isFirstParam) {
    urlParam += '?'
  } else {
    urlParam += '&'
  }
  const regex = /_(.)/g;
  newName = name.replace(regex, function (key, p1) {
    return p1.toUpperCase()
  });
  //console.log(`${name} to ${newName}`);
  let encodeVal = encodeURIComponent(sendVal)

  urlParam += `${newName}=${encodeVal}`;

  return urlParam;
}

const apiClientGet = async (url) => {
  let ret;

  try {
    ret = await axiosClient(url);
  } catch (e) {
    if (e.response.status === 401) {
      // alert(`${url} \n세션이 만료되었습니다. \n 초기 로그인 페이지로 이동합니다.`);
      // console.log(localStorage.getItem('ACCESS_TOKEN'));
      // localStorage.removeItem('ACCESS_TOKEN');
      // localStorage.setItem('LOGIN_MSG', '세션이 만료되었습니다. \r\n 인증이 필요합니다.');
      console.log(sessionStorage.getItem('ACCESS_TOKEN'));
      sessionStorage.removeItem('ACCESS_TOKEN');
      sessionStorage.setItem('LOGIN_MSG', '세션이 만료되었습니다. \r\n 인증이 필요합니다.');
      window.location = '/'
    } else if (e.response.status === 404) {
      //alert('404');
    } else {
      alert(`서버와의 통신이 실패하였습니다.\r\n${e}`);
    }

    console.log(`[통신오류] apiClient Error = ${url} (${e.response.status})`);
  }

  // 데이터 없음
  if (ret.data != undefined) {
    if (ret.data.length == 0) {
      console.log('서버로부터 수신받은 데이터가 없습니다.');
    }
  }

  return ret;
}

const apiClientGetAnon = async (url) => {
  let ret;

  ret = await axiosAnonClient(url);

  return ret;
}


// get file
const apiClientGetFile = async (url) => {
  let ret;

  try {
    ret = await axiosClient.get(url, {
      responseType: 'blob'
    });

  } catch (e) {
    if (e.response.status === 401) {
      console.log(sessionStorage.getItem('ACCESS_TOKEN'));
      sessionStorage.removeItem('ACCESS_TOKEN');
      sessionStorage.setItem('LOGIN_MSG', '세션이 만료되었습니다. \r\n 인증이 필요합니다.');
      window.location = '/'
    } else if (e.response.status === 404) {
      //alert('404');
    } else {
      alert(`서버와의 통신이 실패하였습니다.\r\n${e}`);
    }

    console.log(`[통신오류] apiClient Error = ${url} (${e.response.status})`);
  }

  // 데이터 없음
  if (ret.data != undefined) {
    if (ret.data.length == 0) {
      console.log('서버로부터 수신받은 데이터가 없습니다.');
    }
  }

  return ret;
}

// 로그인
export const postLogin = async (requestBody) => {
  const res = await apiAnonClientPost(`api/v1/cmmn/authenticate`, requestBody);
  sessionStorage.removeItem('ACCESS_TOKEN');
  sessionStorage.removeItem('LOGIN_NAME');

  if (res.data.data.token) {
    // localStorage.setItem('ACCESS_TOKEN', res.data.data.token);
    sessionStorage.setItem('ACCESS_TOKEN', res.data.data.token);
    sessionStorage.setItem('LOGIN_NAME', res.data.data.userId);

    axiosClient.interceptors.request.use(config => {
      // const token = localStorage.getItem('ACCESS_TOKEN');
      const token = sessionStorage.getItem('ACCESS_TOKEN');
      config.headers.Authorization = `Bearer ${token}`;

      return config;
    });

    return res;
  }

  return res;
}

// 로그아웃
export const postLogout = async () => {
  return await apiClientPost(`api/v1/cmmn/logout`);
}

// 대시보드 / 장애 및 성능 / 일별화재발생 현황
export const getDlfocStts = async (searchAtdrcId) => {
  return await apiClientGet(`api/v1/dashbrd/chart-fire/?searchAtdrcId=${searchAtdrcId}`);
}

// 대시보드 장애현황
// API 수정중
export const getDisabilityStatus = async (atdrcId) => {
  //return await apiClientGet(`api/v1/dashbrd/alarms/${atdrcId}/${fcltyNo}`);
  console.log(atdrcId);
  if (atdrcId == '0' || atdrcId == '1') {
    return await apiClientGet(`api/v1/dashbrd/alarms/`);
  }
  return await apiClientGet(`api/v1/dashbrd/alarms/?searchAtdrcId=${atdrcId}`);
}

export const getCardList = async (atdrcId) => {
  //return await apiClientGet(`api/v1/dashbrd/map-cards/${atdrcId}/${fcltyNo}`);
  console.log(`cardlist ${atdrcId}`);
  if (atdrcId == '0' || atdrcId == null || atdrcId == undefined) {
    return await apiClientGet(`api/v1/dashbrd/map-cards`);
  } else {
    return await apiClientGet(`api/v1/dashbrd/map-cards?searchAtdrcId=${atdrcId}`);
  }

}

export const getCardListAnon = async (atdrcId) => {
  console.log(`cardlist ${atdrcId}`);
  if (atdrcId == '0' || atdrcId == null || atdrcId == undefined) {
    return await apiClientGetAnon(`api/ext/dashbrd/map-cards`);
  } else {
    return await apiClientGetAnon(`api/ext/dashbrd/map-cards?searchAtdrcId=${atdrcId}`);
  }
}

export const getLabelList = async () => {
  //return await apiClientGet(`api/v1/dashbrd/map-cards/${atdrcId}/${fcltyNo}`);
  return await apiClientGet(`api/v1/dashbrd/map-points`);
}

export const getLabelListAnon = async () => {
  //return await apiClientGet(`api/v1/dashbrd/map-cards/${atdrcId}/${fcltyNo}`);
  return await apiClientGetAnon(`api/ext/dashbrd/map-points`);
}


// 대시보드 차트1 (일별화재발생현황)
export const getChart1Data = async (atdrcId, fcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/chart-fire`);
}

// 대시보드 차트2
export const getChart2Data = async (atdrcId, fcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/chart-networks`);
}

// 대시보드 차트3
export const getChart3Data = async (atdrcId, fcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/chart-systems`);
}

// 대시보드 시설 마커
export const getFcltyPoint = async (atdrcId) => {
  return await apiClientGet(`api/v1/dashbrd/map-points?searchAtdrcId=${atdrcId}`)
}

export const getFcltyPointAnon = async (atdrcId) => {
  return await apiClientGetAnon(`api/ext/dashbrd/map-points?searchAtdrcId=${atdrcId}`)
}


export const getFloor = async (fcltyNo, floorNo) => {
  return await apiClientGet(`api/v1/dashbrd/map-points?searchFcltyDtlNo=${floorNo}&searchFcltyNo=${fcltyNo}`)
}

// 대시보드 카드
export const getMapCards = async (atdrcId) => {
  return await apiClientGet(`api/v1/dashbrd/map-cards?searchAtdrcId=${atdrcId}`)
}

// 대시보드 카드
export const getMapCardsAnon = async (atdrcId) => {
  return await apiClientGetAnon(`api/ext/dashbrd/map-cards?searchAtdrcId=${atdrcId}`)
}


// 브로커 서버
export const getBrokerURI = async () => {
  return await apiClientGet(`api/v1/cmmn/mqtt/info`)
}

// 대시보드 - 화재 현황
export const getFireStatus = async (pageNum,
                                    pageSize,
                                    searchFromDate,
                                    searchToDate,
                                    searchFcltyNo = '',
                                    searchFireSttus = '',
                                    searchAtdrcId = '',
) => {
  let uri = `api/v1/dashbrd/fire-status?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`;
  uri += `&searchFcltyNo=${searchFcltyNo}`;
  uri += `&searchFireSttus=${searchFireSttus}`;
  return await apiClientGet(uri);
}


// 대시보드 - 화재현황 정보조회 (상단)
export const getFireStatusAlarms = async (fireNo) => {
  return await apiClientGet(`api/v1/dashbrd/fire-status/alarms/${fireNo}`);
}

// 대시보드 - 화재현황 정보조회 (상단) - 경보해제
export const putFireStatusAlarm = async (alarmInfo) => {
  let uri = `api/v1/dashbrd/fire-status/alarms/put/alarm`;
  let isFirst = true;

  Object.keys(alarmInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, alarmInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 대시보드 - 화재 현황 정보조회 (하단)
export const getFireStatusDetail = async (fireNo) => {
  return await apiClientGet(`api/v1/dashbrd/fire-status/${fireNo}`);
}

// 대시보드 - 화재 이벤트 목록
export const getFireStatusEvents = async (pageNum,
                                          pageSize,
                                          searchFireNo = 1,
                                          searchFromDate,
                                          searchToDate) => {
  let uri = `api/v1/dashbrd/fire-status/events?pageNum=${pageNum}&pageSize=${pageSize}&searchFireNo=${searchFireNo}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`;
  return await apiClientGet(uri);
}

// 대시보드 - 시설 상태 정보 - 게이트웨이
export const getFcltyDevicesGateway = async (searchFcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/map-points/facilities/devices/gateway?searchFcltyNo=${searchFcltyNo}`);
}

// 대시보드 - 시설 상태 정보 - 중계기
export const getFcltyDevicesRepeater = async (searchFcltyNo, searchRpeatNo) => {
  console.log(searchFcltyNo, searchRpeatNo);
  return await apiClientGet(`api/v1/dashbrd/map-points/facilities/devices/repeater?searchFcltyNo=${searchFcltyNo}&searchRpeatNo=${searchRpeatNo}`);
}

// 대시보드 - 시설 상태 정보 - 센서
export const getFcltyDevicesSensor = async (searchFcltyNo, searchSensorNo) => {
  return await apiClientGet(`api/v1/dashbrd/map-points/facilities/devices/sensor?searchFcltyNo=${searchFcltyNo}&searchSensorNo=${searchSensorNo}`);
}


// 공통관리 - 접근 가능 메뉴 (전체)
export const getAuthMenus = async (menuId) => {
  if (menuId === undefined || menuId === null) {
    return await apiClientGet(`api/v1/cmmn/auth/menus`);
  } else {
    return await apiClientGet(`api/v1/cmmn/auth/menus?menuId=${menuId}`);
  }
};

// 공통관리 - 비밀번호 확인
export const postIsPassword = async (password) => {
  return await apiClientPost(`api/v1/cmmn/auth/is-password`, {
    "password": password,
  });
};

// 공통관리 - 비밀번호 변경
export const postRePassword = async (password) => {
  return await apiClientPost(`api/v1/cmmn/auth/re-password`, {
    'extendTy': '1',
    'newPassword': `${password.newPassword}`,
    'password': `${password.currentPassword}`
  });
}

// 공통관리 - 제어유형 목록 (게이트웨이)
export const getDeviceCtls = async (deviceTy = 1) => {
  return await apiClientGet(`api/v1/cmmn/codes/devicectl?searchDeviceTy=${deviceTy}`);
};

// 공통관리 - 공통코드 목록 (OGDP)
export const getOGDP = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=OGDP`);
};

// 공통관리 - 공통코드 목록 (OGDP)
export const getUserGrade = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=USERGRADE`);
};


// 공통관리 - 공통코드 목록 (DEVICE_TYPE)
export const getSensorType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=SENSOR_TYPE`);
};


// 공통관리 - 공통코드 목록 (DEVICE_TYPE)
export const getDeviceType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=DEVICE_TYPE`);
};

// 공통관리 - 공통코드 목록 (DEVICE_TYPE)
export const getMqttType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=MQTTTYPE`);
};


// 공통관리 - 공통코드 목록 (FIRE_STATUS)
export const getFireStatusType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=FIRE_STATUS`);
};

// 공통관리 - 공통코드 목록 (FIRE_ENDRESN)
export const getFireCauseType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=FIRE_ENDRESN`);
};

// 공통관리 - 공통코드 발생유형 목록 (ALARM_LC_KND)
export const getLcKndType = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=ALARM_LC_KND`);
};

// 공통관리 - 공통코드 발송대상장애 목록 (SEND_ALARMTYPE)
export const getTrgtAlarm = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=SEND_ALARMTYPE`);
}

// 공통관리 - 공통코드 심각도 목록 (SERIUS_LEVEL)
export const getSeriusLevel = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=SERIUS_LEVEL`);
}

// 공통관리 - 공통코드 장애상태 목록 (SERIUS_LEVEL)
export const getSeriusStatus = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=SERIUS_STATUS`);
}

// 공통관리 - 공통코드 차트 목록 (REPORT_CHART)
export const getReportChart = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=REPORT_CHART`);
}

// 공통관리 - 자치구 목록
export const getDistricts = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/districts`);
}

// 공통관리 - 시설 목록
export const getFacility = async (searchAtdrcId) => {
  return await apiClientGet(`api/v1/cmmn/codes/facilities?searchAtdrcId=${searchAtdrcId}`);
};

// 공통관리 - 게이트웨이 목록
export const getGateway = async (searchAtdrcId, searchFcltyNo) => {
  return await apiClientGet(`api/v1/cmmn/codes/gateways?searchAtdrcId=${searchAtdrcId}&searchFcltyNo=${searchFcltyNo}`);
};

// 공통관리 - 시설 층 목록
export const getFloors = async (searchAtdrcId = null,
                                searchFcltyNo = null) => {
  return await apiClientGet(`api/v1/cmmn/codes/floors?searchAtdrcId=${searchAtdrcId}&searchFcltyNo=${searchFcltyNo}`);
}

// 공통관리 - 중계기 목록
export const getRpts = async (searchAtdrcId = null,
                              searchFcltyDtlNo = null,
                              searchFcltyNo = null,
                              searchGtwyNo = null) => {
  return await apiClientGet(`api/v1/cmmn/codes/repeaters?searchAtdrcId=${searchAtdrcId}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchFcltyNo=${searchFcltyNo}&searchGtwyNo=${searchGtwyNo}`);
}

// 공통관리 - 센서 목록
export const getSensors = async (searchAtdrcId = null,
                                 searchFcltyDtlNo = null,
                                 searchFcltyNo = null,
                                 searchGtwyNo = null,
                                 searchRpeatNo = null,
                                 searchSensorTy = null) => {
  return await apiClientGet(`api/v1/cmmn/codes/repeaters?searchAtdrcId=${searchAtdrcId}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchFcltyNo=${searchFcltyNo}&searchGtwyNo=${searchGtwyNo}&searchRpeatNo=${searchRpeatNo}&searchSensorTy=${searchSensorTy}`);
}

export const getRealtimeFire = async () => {
  return await apiClientGet(`api/ext/status/fire`);
  // return await apiClientGet(`api/v1/cmmn/status/fire`);
}

// 공통관리 - 펌웨어 목록
export const getFirmwareList = async (deviceTy) => {
  return await apiClientGet(`api/v1/cmmn/codes/firmware?searchDeviceTy=${deviceTy}`);
}

// 공통관리 - 사용자 목록 (전체)
export const getUserAll = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/users`);
}


// 구성관리 - 이동약자시설 목록
export const getCMFWList = async (pageNum, pageSize, searchAtdrcId, searchFcltyNo) => {
  let uri = `api/v1/mgmtconf/facilities/`;

  uri += urlAddParam('pageNum', pageNum, true);
  uri += urlAddParam('pageSize', pageSize);
  uri += urlAddParam('searchAtdrcId', searchAtdrcId);
  uri += urlAddParam('searchFcltyNo', searchFcltyNo);

  console.log(uri);
  return await apiClientGet(uri);
}

// 구성관리 - 이동약자시설 목록 전체
export const getCMFWListAll = async (searchAtdrcId, searchFcltyNm) => {
  return await apiClientGet(`api/v1/mgmtconf/facilities-all/?searchAtdrcId=${searchAtdrcId}&searchFcltyNm=${searchFcltyNm}`);
}


// 구성관리 - 이동약자시설 - 정보조회
export const getCMFWListInfo = async (fcltyNo) => {
  return await apiClientGet(`api/v1/mgmtconf/facilities/${fcltyNo}`);
}

// 구성관리 - 이동약자시설 - 정보조회
export const getCMFWListInfoRead = async (fcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/map-points/facilities/info?searchFcltyNo=${fcltyNo}`);
}

// 구성관리 - 이동약자시설 - 층 정보 목록
export const getCMFWListFI = async (fcltyNo) => {
  return await apiClientGet(`api/v1/dashbrd/map-points/facilities/floor?searchFcltyNo=${fcltyNo}`);
  //return await apiClientGet(`api/v1/mgmtconf/facilities/${fcltyNo}/floors`);
}

// 구성관리 - 이동약자시설 - 층 정보 조회
export const getCMFWListFIInfo = async (fcltyNo, fcltyDtlNo) => {
  return await apiClientGet(`api/v1/mgmtconf/facilities/${fcltyNo}/floors/${fcltyDtlNo}`);
}

// 구성관리 - 이동약자시설 삭제
export const modFireStatus = async (fireNo, fireSttus, endResn, endDtlResn) => {
  let uri = 'api/v1/dashbrd/fire-status/put/status';
  uri += `?fireNo=${fireNo}`;
  uri += `&fireSttus=${fireSttus}`;
  // uri += `&endResn=${endResn}`;
  // uri += `&endDtlResn=${endDtlResn}`;

  return await apiClientPost(uri);
}

// 구성관리 - 이동약자시설 삭제
export const delCMFWList = async (fcltyNo) => {
  return await apiClientPost(`api/v1/mgmtconf/facilities/delete/facility?fcltyNo=${fcltyNo}`);
}

// 구성관리 - 이동약자시설 층별 정보 삭제
export const delCMFWListFI = async (fcltyNo) => {
  return await apiClientPost(`api/v1/mgmtconf/facilities/delete/facility?fcltyNo=${fcltyNo}`);
}

// 구성관리 - 이동약자시설 등록
export const regCMFWList = async (atdrcId,
                                  elvtrEnncYn,
                                  fcltyNm,
                                  fcltyPrpos,
                                  grndNofl,
                                  instlDe,
                                  locplcAddr,
                                  locplcLa,
                                  locplcLo,
                                  picTelno,
                                  puloutInfo,
                                  remark,
                                  strct,
                                  udgdNofl,
                                  useSttus,
                                  wallMtrqlt
) => {
  let uri = `api/v1/mgmtconf/facilities/post/facility`;
  uri += `?atdrcId=${atdrcId}`;
  uri += `&elvtrEnncYn=${elvtrEnncYn}`
  uri += `&fcltyNm=${fcltyNm}`
  uri += `&fcltyPrpos=${fcltyPrpos}`
  uri += `&grndNofl=${grndNofl}`
  uri += `&instlDe=${instlDe}`
  uri += `&locplcAddr=${locplcAddr}`
  uri += `&locplcLa=${locplcLa}`
  uri += `&locplcLo=${locplcLo}`
  uri += `&picTelno=${picTelno}`
  uri += `&puloutInfo=${puloutInfo}`
  uri += `&remark=${remark}`
  uri += `&strct=${strct}`
  uri += `&udgdNofl=${udgdNofl}`
  uri += `&useSttus=${useSttus}`
  uri += `&wallMtrqlt=${wallMtrqlt}`

  return await apiClientPost(uri)
}

// 구성관리 - 이동약자시설 등록
export const regCmfwSt = async (stFacilityInfo) => {
  let uri = `api/v1/mgmtconf/facilities/post/facility`;
  let isFirst = true;

  Object.keys(stFacilityInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, stFacilityInfo[key], isFirst);
    isFirst = false
  })


  console.log(uri);

  return await apiClientPost(uri)
}

// 구성관리 - 이동약자시설 수정
export const modCmfwSt = async (stFacilityInfo) => {

  let uri = `api/v1/mgmtconf/facilities/put/facility`;
  let isFirst = true;

  Object.keys(stFacilityInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, stFacilityInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 구성관리 - 이동약자시설 층별 정보 수정
/*export const putCMFWFloor = async (fcltyDtlNm, fcltyDtlNo, fcltyDtlSn, fcltyNo, file) => {
  const formData = new FormData();
  formData.append("fcltyDtlNm", fcltyDtlNm);
  formData.append("fcltyDtlNo", fcltyDtlNo);
  formData.append("fcltyDtlSn", fcltyDtlSn);
  formData.append("fcltyNo", fcltyNo);

  return await apiClientPostFormData(`api/v1/mgmtconf/facilities/put/floors`, formData);
};*/

// // 구성관리 - 이동약자시설 층별 정보 수정
// export const putCMFWFloor = async (floorAddInputs) => {
//     console.log(floorAddInputs);
//     let uri = `api/v1/mgmtconf/facilities/put/floors`;
//     let isFirst = true;
//
//     Object.keys(floorAddInputs).map((key, value) => {
//         console.log(`${key} : ${floorAddInputs[key]}`);
//         uri += urlAddParam(key, floorAddInputs[key], isFirst);
//         isFirst = false;
//     });
//
//     console.log(uri);
//     return await apiClientPost(uri);
// };

// 구성관리 - 이동약자시설 층별 정보 등록
export const postCMFWFloor = async (floorAddInputs) => {
  console.log(floorAddInputs);
  let uri = `api/v1/mgmtconf/facilities/post/floors`;
  let isFirst = true;

  // Object.keys(floorAddInputs).map((key, value) => {
  //   console.log(`${key} : ${floorAddInputs[key]}`);
  //   uri += urlAddParam(key, floorAddInputs[key], isFirst);
  //   isFirst = false;
  // });
  // urlAddParam('fcltyNo', floorAddInputs.fcltyNo, true)
  // urlAddParam('fcltyDtlNm', floorAddInputs.fcltyDtlNm, false)

  let formData = new FormData()

  formData.append('fcltyNo', floorAddInputs.fcltyNo);
  formData.append('fcltyDtlNm', floorAddInputs.fcltyDtlNm);
  formData.append('fcltyDtlSn', '1');
  formData.append('file', floorAddInputs.filepath);

  console.log(formData);
  // let data = {
  //   fcltyNo: floorAddInputs.fcltyNo,
  //   fcltyDtlNm: floorAddInputs.fcltyDtlNm,
  //   fcltyDtlSn: '1',
  //   file: floorAddInputs.filepath
  // };
  // console.log("## data :: ", data);
  return await apiClientPostFormData(uri, formData);


  // console.log(uri);
  // return await apiClientPost(uri);
};

// 구성관리 - 이동약자시설 층별 정보 수정
export const putCMFWFloor = async (floorAddInputs) => {
  console.log(floorAddInputs);
  let uri = `api/v1/mgmtconf/facilities/put/floors`;
  let isFirst = true;

  // Object.keys(floorAddInputs).map((key, value) => {
  //   console.log(`${key} : ${floorAddInputs[key]}`);
  //   uri += urlAddParam(key, floorAddInputs[key], isFirst);
  //   isFirst = false;
  // });
  // urlAddParam('fcltyNo', floorAddInputs.fcltyNo, true)
  // urlAddParam('fcltyDtlNm', floorAddInputs.fcltyDtlNm, false)

  let formData = new FormData()

  formData.append('fcltyNo', floorAddInputs.fcltyNo);
  formData.append('fcltyDtlNo', floorAddInputs.fcltyDtlNo);
  formData.append('fcltyDtlNm', floorAddInputs.fcltyDtlNm);
  formData.append('fcltyDtlSn', '1');
  if (floorAddInputs.filepath) {
    formData.append('file', floorAddInputs.filepath);
  }

  console.log(formData);
  return await apiClientPostFormData(uri, formData);


  // console.log(uri);
  // return await apiClientPost(uri);
};

// 구성관리 - 이동약자시설 층별 정보 삭제
export const delCMFWFloor = async (floorAddInputs) => {
  console.log(floorAddInputs);
  let uri = `api/v1/mgmtconf/facilities/delete/floors`;

  let formData = new FormData()

  formData.append('fcltyNo', floorAddInputs.fcltyNo);
  formData.append('fcltyDtlNo', floorAddInputs.fcltyDtlNo);

  console.log(formData);
  return await apiClientPostFormData(uri, formData);
};

// 구성관리 - 이동약자시설 층별 정보 삭제 (수정ver)
export const delCMFWFloors = async (fcltyDtlNo, fcltyNo) => {
  let uri = `api/v1/mgmtconf/facilities/delete/floors`;
  uri += urlAddParam('fcltyDtlNo', fcltyDtlNo, true);
  uri += urlAddParam('fcltyNo', fcltyNo, false);

  console.log(uri);
  return await apiClientPost(uri);
}

// 구성관리 - 이동약자시설 층별 순서 수정(일괄)
export const putCMFWFloorOrder = async (paramList) => {
  console.log(paramList);
  let uri = `api/v1/mgmtconf/facilities/put-all/floors/position`;
  let isFirst = true;

  /*Object.keys(floorInfo).map((key, value) => {
    console.log(`${key} : ${floorInfo[key]}`);
    uri += urlAddParam(key, floorInfo[key], isFirst);
    isFirst = false;
  });*/

  /*console.log(uri);
  return await apiClientPost(uri);*/

  let data = {
    paramList: paramList
  };

  console.log("## data :: ", data);
  return await apiClientPostJsonData(uri, data);
}

// 구성관리 - 게이트웨이 목록
export const getGWList = async (pageNum, pageSize, searchAtdrcId, searchFcltyNm) => {
  return await apiClientGet(`api/v1/mgmtconf/gateways/?pageNum=${pageNum}&pageSize=${pageSize}&searchAtdrcId=${searchAtdrcId}&searchFcltyNm=${searchFcltyNm}`);
}

// 구성관리 - 게이트웨이 목록 - 전체
export const getGWListAll = async (pageNum, pageSize, searchAtdrcId, searchFcltyNm) => {
  return await apiClientGet(`api/v1/mgmtconf/gateways-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchAtdrcId=${searchAtdrcId}&searchFcltyNm=${searchFcltyNm}`);
}

// 구성관리 - 게이트웨이 정보 조회
export const getGWInfo = async (gtwyNo) => {
  return await apiClientGet(`api/v1/mgmtconf/gateways/${gtwyNo}`);
}

// 구성관리 - 게이트웨이 등록
// API 명세서 요청 필요
export const postGW = async (gwInfo) => {
  let uri = `api/v1/mgmtconf/gateways/post/gateway`;
  // let isFirst = true;

  // Object.keys(gwInfo).map((key, value) => {
  //   //console.log(`${key} : ${stFacilityInfo[key]}`);
  //   uri += urlAddParam(key, gwInfo[key], isFirst);
  //   isFirst = false
  // })

  // console.log(uri);
  // return await apiClientPost(uri)
  let formData = new FormData()

  console.log(gwInfo)

  formData.append('cctvPoleNo', gwInfo.cctv_pole_no);
  formData.append('fcltyNo', gwInfo.fclty_no);
  formData.append('gtwyId', gwInfo.gtwy_id);
  formData.append('gtwyNo', gwInfo.gtwy_no);
  formData.append('ip1Addr', gwInfo.ip1_addr);
  formData.append('ip2Addr', gwInfo.ip2_addr);
  formData.append('l2IpAddr', gwInfo.l2_ip_addr);
  formData.append('la', gwInfo.la);
  formData.append('lo', gwInfo.lo);

  // formData.append('remark', gwInfo.remark);
  // formData.append('fwVer', gwInfo.fwVer);

  formData.append('instlDe', gwInfo.instl_de ? gwInfo.instl_de : '');
  formData.append('mkr', gwInfo.mkr ? gwInfo.mkr : '');
  formData.append('modl', gwInfo.modl ? gwInfo.modl : '');
  formData.append('sid', gwInfo.sid ? gwInfo.sid : '');

  if (gwInfo.filepath) {
    formData.append('file', gwInfo.filepath);
  }

  console.log(formData);
  return await apiClientPostFormData(uri, formData);
}

// 구성관리 - 게이트웨이 수정
// API 명세서 요청 필요
export const putGW = async (gwInfo) => {
  let uri = `api/v1/mgmtconf/gateways/put/gateway`;
  // let isFirst = true;
  //
  // Object.keys(gwInfo).map((key, value) => {
  //   //console.log(`${key} : ${stFacilityInfo[key]}`);
  //   uri += urlAddParam(key, gwInfo[key], isFirst);
  //   isFirst = false
  // })
  //
  // console.log(uri);
  // return await apiClientPost(uri)
  let formData = new FormData()

  console.log(gwInfo)

  formData.append('cctvPoleNo', gwInfo.cctv_pole_no);
  formData.append('fcltyNo', gwInfo.fclty_no);
  formData.append('gtwyId', gwInfo.gtwy_id);
  formData.append('gtwyNo', gwInfo.gtwy_no);
  formData.append('ip1Addr', gwInfo.ip1_addr);
  formData.append('ip2Addr', gwInfo.ip2_addr);
  formData.append('l2IpAddr', gwInfo.l2_ip_addr);
  formData.append('la', gwInfo.la);
  formData.append('lo', gwInfo.lo);
  // formData.append('fwVer', gwInfo.fwVer);

  formData.append('instlDe', gwInfo.instl_de ? gwInfo.instl_de : '');
  formData.append('mkr', gwInfo.mkr ? gwInfo.mkr : '');
  formData.append('modl', gwInfo.modl ? gwInfo.modl : '');
  formData.append('sid', gwInfo.sid ? gwInfo.sid : '');

  if (gwInfo.filepath) {
    formData.append('file', gwInfo.filepath);
  }

  console.log(formData);
  return await apiClientPostFormData(uri, formData);
}

// 구성관리 - 게이트웨이 삭제
// 등록 버그로 인한 삭제 테스트 불가
export const delGW = async (gtwyNo) => {
  console.log(`delete ${gtwyNo}`);
  return await apiClientPost(`api/v1/mgmtconf/gateways/delete/gateway?gtwyNo=${gtwyNo}`);
}

// 구성관리 - 제어 (임시, 펌웨어)
export const postDeviceCtl = async (stInfo, paramSize = 3) => {
  let uri = `api/v1/mgmtconf/ctrl/post-all/devices`;
  let paramList = new Array();

  if (stInfo.ctrlTy == '306') {
    for (let i = 0; i < 3; i++) {
      if (stInfo[`paramtr${i + 1}`]) {
        console.log(stInfo[`paramtr${i + 1}`])
      } else {
        throw new Error('파라미터를 반드시 설정하여야 합니다.');
      }
    }
    paramList.push({
      'deviceId': stInfo.deviceID,
      'ctrlTy': stInfo.ctrlTy,
      'paramtr1': stInfo.paramtr1,
      'paramtr2': stInfo.paramtr2,
      'paramtr3': stInfo.paramtr3.toString(),
    });
  } else {
    for (let i = 0; i < paramSize; i++) {
      if (stInfo[`paramtr${i + 1}`]) {
        console.log(stInfo[`paramtr${i + 1}`])
      } else {
        throw new Error('파라미터를 반드시 설정하여야 합니다.');
      }
    }
    paramList.push({
      'deviceId': stInfo.deviceID,
      'ctrlTy': stInfo.ctrlTy,
      'paramtr1': stInfo.paramtr1,
      'paramtr2': stInfo.paramtr2,
      'paramtr3': stInfo.paramtr3
    });
  }

  let data = {
    paramList: paramList
  };
  console.log("## data :: ", data);
  return await apiClientPostJsonData(uri, data);
}

// 구성관리 - 게이트웨이 제어유형 목록
// 1: 게이트웨이 2: 중계기 3:센서
export const getDeviceCtlType = async (searchDeviceTy) => {
  return await apiClientGet(`api/v1/cmmn/codes/devicectl?searchDeviceTy=${searchDeviceTy}`);
}

// 구성관리 - 게이트웨이 제어유형 목록
export const getGWDeviceCtl = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/devicectl?searchDeviceTy=1`);
}

// 구성관리 - 중계기 센서유형 목록
export const getRptDeviceSSCtl = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/devicectl?searchDeviceTy=2`);
}

// 구성관리 - 중계기 수정
export const putRptDevice = async (stRptInfo) => {
  let uri = `api/v1/mgmtconf/repeaters/put/repeater`;
  let isFirst = true;

  // Object.keys(stRptInfo).map((key, value) => {
  //   console.log(`${key} : ${stRptInfo[key]}`);
  //   uri += urlAddParam(key, stRptInfo[key], isFirst);
  //   isFirst = false
  // })
  uri += urlAddParam('fclty_dtl_no', stRptInfo['fclty_dtl_no'], true);
  uri += urlAddParam('rpeat_id', stRptInfo['rpeat_id']);
  uri += urlAddParam('rpeat_no', stRptInfo['rpeat_no']);
  uri += urlAddParam('rpeat_sn', stRptInfo['rpeat_sn']);
  uri += urlAddParam('gtwy_no', stRptInfo['gtwy_no']);
  uri += urlAddParam('mkr', stRptInfo['mkr']);
  uri += urlAddParam('modl', stRptInfo['modl']);
  uri += urlAddParam('sid', stRptInfo['sid']);
  uri += urlAddParam('fclty_lc_nm', stRptInfo['rpeat_lc_nm']);
  uri += urlAddParam('instl_de', stRptInfo['instl_de'] ? stRptInfo['instl_de'] : '');
  uri += urlAddParam('x_crdnt', stRptInfo['x_crdnt'] ? stRptInfo['x_crdnt'] : '0');
  uri += urlAddParam('y_crdnt', stRptInfo['y_crdnt']);

  console.log(uri);
  return await apiClientPost(uri)
}

export const postRptDevice = async (stRptInfo) => {
  let uri = `api/v1/mgmtconf/repeaters/post/repeater`;
  let isFirst = true;

  // Object.keys(stRptInfo).map((key, value) => {
  //   //console.log(`${key} : ${stFacilityInfo[key]}`);
  //   uri += urlAddParam(key, stRptInfo[key], isFirst);
  //   isFirst = false
  // })
  console.log(stRptInfo);

  uri += urlAddParam('fclty_dtl_no', stRptInfo['fclty_dtl_no'], true);
  uri += urlAddParam('rpeat_id', stRptInfo['rpeat_id']);
  uri += urlAddParam('rpeat_no', stRptInfo['rpeat_no']);
  uri += urlAddParam('rpeat_sn', stRptInfo['rpeat_sn']);
  uri += urlAddParam('gtwy_no', stRptInfo['gtwy_no']);
  uri += urlAddParam('mkr', stRptInfo['mkr']);
  uri += urlAddParam('modl', stRptInfo['modl']);
  uri += urlAddParam('sid', stRptInfo['sid']);
  uri += urlAddParam('fclty_lc_nm', stRptInfo['rpeat_lc_nm']);
  uri += urlAddParam('instl_de', stRptInfo['instl_de'] ? stRptInfo['instl_de'] : '');
  uri += urlAddParam('x_crdnt', stRptInfo['x_crdnt'] ? stRptInfo['x_crdnt'] : '0');
  uri += urlAddParam('y_crdnt', stRptInfo['y_crdnt'] ? stRptInfo['y_crdnt'] : '0');

  console.log(uri);
  return await apiClientPost(uri);
}

export const postRptDeviceDelete = async (rpeatNo) => {
  let uri = `api/v1/mgmtconf/repeaters/delete/repeater`;
  uri += urlAddParam('rpeatNo', rpeatNo, true);

  console.log(uri);
  return await apiClientPost(uri);
}

// 구성관리 - 중계기 좌표 저장
export const putRepXY = async (markerList) => {
  let uri = `api/v1/mgmtconf/repeaters/put-all/repeater/position`;
  let data = JSON.stringify({
    "paramList": markerList.filter((item) => item.isModified).map(elem => {
      return {
        'rpeatNo': `${elem.id}`,
        'xCrdnt': `${parseInt(elem.x)}`,
        'yCrdnt': `${parseInt(elem.y)}`
      }
    })
  })

  console.log(data);

  var config = {
    method: 'post',
    url: `${SWAGGER_BASE_URL}${uri}`,
    headers: {
      "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
      'Content-Type': 'application/json'
    },
    data: data
  };

  // //return await apiClientPost(uri, data);
  return await axios(config);
  //return await
}

// 구성관리 - 센서 제어유형(센서) 목록
export const getSSDeviceSSCtl = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/devicectl?searchDeviceTy=3`);
};

// 구성관리 - 센서 수정
export const putSSDevice = async (stSensorInfo) => {
  let uri = `api/v1/mgmtconf/sensors/put/sensor`;
  let isFirst = true;

  // Object.keys(stRptInfo).map((key, value) => {
  //   console.log(`${key} : ${stRptInfo[key]}`);
  //   uri += urlAddParam(key, stRptInfo[key], isFirst);
  //   isFirst = false
  // })
  uri += urlAddParam('fclty_dtl_no', stSensorInfo['fclty_dtl_no'], true);
  uri += urlAddParam('fclty_lc_nm', stSensorInfo['sensor_lc_nm']);
  uri += urlAddParam('rpeat_no', stSensorInfo['rpeat_no']);
  uri += urlAddParam('sensor_id', stSensorInfo['sensor_id']);
  uri += urlAddParam('sensor_no', stSensorInfo['sensor_no']);
  // uri += urlAddParam('sensor_sn', stSensorInfo['sensor_sn']);
  uri += urlAddParam('sensor_ty', stSensorInfo['sensor_ty']);
  uri += urlAddParam('mkr', stSensorInfo['mkr']);
  uri += urlAddParam('instl_de', stSensorInfo['instl_de'] ? stSensorInfo['instl_de'] : '');
  uri += urlAddParam('x_crdnt', stSensorInfo['x_crdnt']);
  uri += urlAddParam('y_crdnt', stSensorInfo['y_crdnt']);
  uri += urlAddParam('sid', stSensorInfo['sid']);
  uri += urlAddParam('modl', stSensorInfo['modl']);

  console.log(stSensorInfo);
  console.log(uri);
  return await apiClientPost(uri)
}

export const postSSDevice = async (stSensorInfo) => {
  let uri = `api/v1/mgmtconf/sensors/post/sensor`;
  let isFirst = true;

  // Object.keys(stRptInfo).map((key, value) => {
  //   //console.log(`${key} : ${stFacilityInfo[key]}`);
  //   uri += urlAddParam(key, stRptInfo[key], isFirst);
  //   isFirst = false
  // })
  uri += urlAddParam('fclty_dtl_no', stSensorInfo['fclty_dtl_no'], true);
  uri += urlAddParam('fclty_lc_nm', stSensorInfo['sensor_lc_nm']);
  uri += urlAddParam('rpeat_no', stSensorInfo['rpeat_no']);
  uri += urlAddParam('sensor_id', stSensorInfo['sensor_id']);
  uri += urlAddParam('sid', stSensorInfo['sid']);
  uri += urlAddParam('modl', stSensorInfo['modl']);
  // uri += urlAddParam('sensor_no', stSensorInfo['sensor_no']);
  // uri += urlAddParam('sensor_sn', stSensorInfo['sensor_sn']);
  uri += urlAddParam('sensor_ty', stSensorInfo['sensor_ty']);
  uri += urlAddParam('mkr', stSensorInfo['mkr']);
  uri += urlAddParam('instl_de', stSensorInfo['instl_de'] ? stSensorInfo['instl_de'] : '');
  uri += urlAddParam('x_crdnt', stSensorInfo['x_crdnt'] ? stSensorInfo['x_crdnt'] : '0');
  uri += urlAddParam('y_crdnt', stSensorInfo['y_crdnt'] ? stSensorInfo['y_crdnt'] : '0');

  console.log(uri);
  return await apiClientPost(uri)
}

export const postSSDeviceDelete = async (sensorNo) => {
  let uri = `api/v1/mgmtconf/sensors/delete/sensor`;
  uri += urlAddParam('sensorNo', sensorNo, true);

  console.log(uri);
  return await apiClientPost(uri);
}


// 구성관리 - 센서 좌표 저장
export const putSSDeviceXY = async (markerList) => {
  let uri = `api/v1/mgmtconf/sensors/put-all/sensor/position`;
  let data = JSON.stringify({
    "paramList": markerList.filter((item) => item.isModified).map(elem => {
      return {
        'sensorNo': `${elem.id}`,
        'xCrdnt': elem.x ? `${parseInt(elem.x)}` : '',
        'yCrdnt': elem.y ? `${parseInt(elem.y)}` : ''
      }
    })
  })

  console.log(data);

  var config = {
    method: 'post',
    url: `${SWAGGER_BASE_URL}${uri}`,
    headers: {
      "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
      'Content-Type': 'application/json'
    },
    data: data
  };

  // //return await apiClientPost(uri, data);
  return await axios(config);
  //return await
}


// 공통관리 - 공통코드 목록 - 센서구분
export const getSSDeviceTy = async () => {
  return await apiClientGet(`api/v1/cmmn/codes/common?pcode=SENSOR_TYPE`);
};

// 구성관리 - 중계기 목록
export const getRPTList = async (pageNum, pageSize, searchAtdrcId, searchFcltyDtlNo, searchFcltyLcNm, searchFcltyNo, searchSetupYn) => {
  return await apiClientGet(`api/v1/mgmtconf/repeaters/?pageNum=${pageNum}&pageSize=${pageSize}&searchAtdrcId=${searchAtdrcId}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchFcltyLcNm=${searchFcltyLcNm}&searchFcltyNo=${searchFcltyNo}&searchSetupYn=${searchSetupYn}`);
}

// 구성관리 - 중계기 - 등록
export const regRepeater = async (fcltyDtlNo,
                                  fcltyLcNm,
                                  fwVer = null,
                                  gtwyNo,
                                  instlDe = null,
                                  mkr = null,
                                  modl = null,
                                  rpeatId,
                                  rpeatSn) => {
  return await apiClientPost(`api/v1/mgmtconf/repeaters/post/repeater?fcltyDtlNo=${fcltyDtlNo}&fcltyLcNm=${fcltyLcNm}&fwVer=${fwVer}&gtwyNo=${gtwyNo}&instlDe=${instlDe}&mkr=${mkr}&modl=${modl}&rpeatId=${rpeatId}&rpeatSn=${rpeatSn}`);
};

// 구성관리 - 중계기 정보 조회
export const getRPTInfo = async (rpeatNo) => {
  return await apiClientGet(`api/v1/mgmtconf/repeaters/${rpeatNo}`);
}

// 공통관리 - 게이트웨이 정보 조회
export const getGateInfo = async (fcltyNo) => {
  return await apiClientGet(`api/v1/cmmn/codes/gateways?searchFcltyNo=${fcltyNo}`);
}


// 구성관리 - 센서 장비 목록
export const getSSList = async (pageNum,
                                pageSize,
                                searchAtdrcId,
                                searchFcltyDtlNo,
                                searchFcltyLcNm,
                                searchFcltyNo,
                                searchRpeatNo,
                                searchSensorTy,
                                searchSetupYn) => {
  return await apiClientGet(`api/v1/mgmtconf/sensors?pageNum=${pageNum}&pageSize=${pageSize}&searchAtdrcId=${searchAtdrcId}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchFcltyLcNm=${searchFcltyLcNm}&searchFcltyNo=${searchFcltyNo}&searchRpeatNo=${searchRpeatNo}&searchSensorTy=${searchSensorTy}&searchSetupYn=${searchSetupYn}`);
}

// 구성관리 - 센서 장비 정보 조회
export const getSSInfo = async (sensorNo) => {
  return await apiClientGet(`api/v1/mgmtconf/sensors/${sensorNo}`);
}

// 구성관리 - 제어이력 - 게이트웨이 목록
export const getCtlGWList = async (pageNum = 1,
                                   pageSize = 15,
                                   searchCtrlTy = null,
                                   searchFcltyNo = null,
                                   searchFromDate,
                                   searchToDate,
                                   searchFromSi,
                                   searchToSi) => {
  let uri = `api/v1/mgmtconf/history/gateways/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;

  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchCtrlTy=${searchCtrlTy}`

  return await apiClientGet(uri);
}

// 구성관리 - 제어이력 - 게이트웨이 목록
export const getCtlGWListAll = async (pageNum = 1,
                                      pageSize = 15,
                                      searchCtrlTy = null,
                                      searchFcltyNo = null,
                                      searchFromDate,
                                      searchToDate,
                                      searchFromSi,
                                      searchToSi) => {
  let uri = `api/v1/mgmtconf/history/gateways-all/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;

  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchCtrlTy=${searchCtrlTy}`

  return await apiClientGet(uri);
}

// 구성관리 - 제어이력 - 중계기 목록
export const getCtlRPTList = async (pageNum = 1,
                                    pageSize = 15,
                                    searchCtrlTy = null,
                                    searchFcltyNo = null,
                                    searchFromDate,
                                    searchRpeatNo = null,
                                    searchToDate,
                                    searchFromSi,
                                    searchToSi) => {
  let uri = `api/v1/mgmtconf/history/repeaters/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;

  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchRpeatNo=${searchRpeatNo}`
  uri += `&searchCtrlTy=${searchCtrlTy}`

  return await apiClientGet(uri);
}

// 구성관리 - 제어이력 - 중계기 목록
export const getCtlRPTListAll = async (pageNum = 1,
                                       pageSize = 15,
                                       searchCtrlTy = null,
                                       searchFcltyNo = null,
                                       searchFromDate,
                                       searchRpeatNo = null,
                                       searchToDate,
                                       searchFromSi,
                                       searchToSi) => {
  let uri = `api/v1/mgmtconf/history/repeaters-all/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;

  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchRpeatNo=${searchRpeatNo}`
  uri += `&searchCtrlTy=${searchCtrlTy}`

  return await apiClientGet(uri);
}

// 구성관리 - 제어이력 - 센서 목록
export const getCtlSSList = async (pageNum = 1,
                                   pageSize = 15,
                                   searchCtrlTy = null,
                                   searchDeviceTy = null,
                                   searchFcltyNo = null,
                                   searchFromDate,
                                   searchRpeatNo = null,
                                   searchSensorId = null,
                                   searchToDate,
                                   searchFromSi,
                                   searchToSi) => {
  let uri = `api/v1/mgmtconf/history/sensors/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;
  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchRpeatNo=${searchRpeatNo}`
  uri += `&searchDeviceTy=${searchDeviceTy}`
  uri += `&searchCtrlTy=${searchCtrlTy}`
  uri += `&searchSensorId=${searchSensorId}`

  return await apiClientGet(uri);
}

// 구성관리 - 제어이력 - 센서 목록
export const getCtlSSListAll = async (pageNum = 1,
                                      pageSize = 15,
                                      searchCtrlTy = null,
                                      searchDeviceTy = null,
                                      searchFcltyNo = null,
                                      searchFromDate,
                                      searchRpeatNo = null,
                                      searchSensorId = null,
                                      searchToDate,
                                      searchFromSi,
                                      searchToSi) => {
  let uri = `api/v1/mgmtconf/history/sensors-all/`
  uri += `?pageNum=${pageNum}&pageSize=${pageSize}`
  uri += `&searchFromDate=${searchFromDate}`
  uri += `&searchToDate=${searchToDate}`;
  uri += `&searchFromSi=${searchFromSi}`;
  uri += `&searchToSi=${searchToSi}`;
  uri += `&searchFcltyNo=${searchFcltyNo}`
  uri += `&searchRpeatNo=${searchRpeatNo}`
  uri += `&searchDeviceTy=${searchDeviceTy}`
  uri += `&searchCtrlTy=${searchCtrlTy}`
  uri += `&searchSensorId=${searchSensorId}`

  return await apiClientGet(uri);
}

// 구성관리 - 시스템
export const getSystem = async (pageNum = 1,
                                pageSize = 15) => {
  return await apiClientGet(`api/v1/mgmtconf/systems?pageNum=${pageNum}&pageSize=${pageSize}`);
}

// 구성관리 - 시스템 전체
export const getSystemAll = async () => {
  return await apiClientGet(`api/v1/mgmtconf/systems-all`);
}

// 구성관리 - 시스템 정보조회
export const getSystemInfo = async (sysNo) => {
  return await apiClientGet(`api/v1/mgmtconf/systems/${sysNo}`);
}

// 구성관리 - 시스템 등록
export const regSystemInfo = async (info) => {
  let uri = `api/v1/mgmtconf/systems/post/system`;
  let isFirst = true;

  Object.keys(info).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, info[key], isFirst);
    isFirst = false;
  });

  // console.log(uri);
  return await apiClientPost(uri)
}

// 구성관리 - 시스템 삭제
export const delSystemInfo = async (sysNo) => {
  return await apiClientPost(`api/v1/mgmtconf/systems/delete/system?sysNo=${sysNo}`);
}

// 구성관리 - 시스템 수정
export const putSystemInfo = async (info) => {
  let uri = `api/v1/mgmtconf/systems/put/system`;
  let isFirst = true;

  Object.keys(info).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, info[key], isFirst);
    isFirst = false;
  });

  // console.log(uri);
  return await apiClientPost(uri)
}


// 구성관리 - 유무선통신장비 - CCTV 목록
export const getCmnctCctvList = async (pageNum = 1,
                                       pageSize = 15,
                                       searchAtdrcId = null) => {
  return await apiClientGet(`api/v1/mgmtconf/cctvs?pageNum=${pageNum}&pageSize=${pageSize}&searchAtdrcId=${searchAtdrcId}`);
}

// 구성관리 - 유무선통신장비 - CCTV 전체
export const getCmnctCctvListAll = async (searchAtdrcId) => {
  return await apiClientGet(`api/v1/mgmtconf/cctvs-all?searchAtdrcId=${searchAtdrcId}`);
}

// 구성관리 - 유무선통신장비 - CCTV 정보조회
export const getCmnctCctvInfo = async (cctvNo) => {
  return await apiClientGet(`api/v1/mgmtconf/cctvs/${cctvNo}`);
}

// 구성관리 - 유무선통신장비 - CCTV 등록
export const regCmnctCctvInfo = async (info) => {
  let uri = `api/v1/mgmtconf/cctvs/post/cctv`;
  const formData = new FormData();

  formData.append('atdrcId', info.atdrc_id);
  formData.append('cctvNm', info.cctv_nm);
  formData.append('cctvNo', info.cctv_no);
  formData.append('cctvPoleNo', info.cctv_pole_no);
  formData.append('instlDe', info.instl_de);
  formData.append('la', info.la);
  formData.append('lo', info.lo);
  formData.append('locplcAddr', info.locplc_addr);
  formData.append('modl', info.modl);

  if (info.filepath) {
    formData.append('file', info.filepath);
  }

  // console.log(uri);
  return await apiClientPostFormData(uri, formData);
}

// 구성관리 - 유무선통신장비 - CCTV 수정
export const putCmnctCctvInfo = async (info) => {
  const formData = new FormData();

  console.log(info);

  formData.append('atdrcId', info.atdrc_id);
  formData.append('cctvNm', info.cctv_nm);
  formData.append('cctvNo', info.cctv_no);
  formData.append('cctvPoleNo', info.cctv_pole_no);
  formData.append('instlDe', info.instl_de);
  formData.append('la', info.la);
  formData.append('lo', info.lo);
  formData.append('locplcAddr', info.locplc_addr);
  formData.append('modl', info.modl);

  if (info.filepath) {
    console.log(info.filepath)
    formData.append('file', info.filepath);
  }

  console.log(formData);

  return await apiClientPostFormData(`api/v1/mgmtconf/cctvs/put/cctv`, formData);
}

// 구성관리 - 유무선통신장비 - CCTV 삭제
export const delCmnctCctvInfo = async (cctvNo) => {
  return await apiClientPost(`api/v1/mgmtconf/cctvs/delete/cctv?cctvNo=${cctvNo}`);
}

// 구성관리 - 유무선통신장비 - CCTV 이미지 삭제
export const delCmnctCctvImg = async (cctvNo) => {
  return await apiClientPost(`api/v1/mgmtconf/cctvs/delete/cctv/image?cctvNo=${cctvNo}`);
}

// 구성관리 - 유무선통신장비 - 게이트웨이 이미지 삭제
export const delCmnctGtwyImg = async (gtwyNo) => {
  return await apiClientPost(`api/v1/mgmtconf/gateways/delete/gateway/image?gtwyNo=${gtwyNo}`);
}


// 장애관리 - 장애현황 목록
export const getFSList = async (pageNum = 1,
                                pageSize = 15,
                                searchFcltyNo = null,
                                searchLcKnd = null,
                                searchMssage = null) => {
  return await apiClientGet(`api/v1/mgmtfult/statuses/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchLcKnd=${searchLcKnd}&searchMssage=${searchMssage}`);
}

// 장애관리 - 장애현황 목록 - 전체
export const getFSListAll = async (searchFcltyNo, searchLcKnd, searchMssage) => {
  return await apiClientGet(`api/v1/mgmtfult/statuses-all?searchFcltyNo=${searchFcltyNo}&searchLcKnd=${searchLcKnd}&searchMssage=${searchMssage}`);
}

// 장애관리 - 장애이력 목록
export const getFHList = async (pageNum = 1,
                                pageSize = 15,
                                searchFcltyNo = null,
                                searchFromDate,
                                searchFromSi = '00',
                                searchLcKnd = null,
                                searchMssage = null,
                                searchSeriusLevel = null,
                                searchSttus = null,
                                searchToDate,
                                searchToSi = '23'
) => {

  // console.log("get API LIST !!!!!!!!");
  // api/v1/mgmtfult/histories?pageNum=1&pageSize=1000&searchFromDate=2023-05-10&searchFromSi=00&searchToDate=2023-05-17&searchToSi=23
  return await apiClientGet(`api/v1/mgmtfult/histories?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}&searchFromSi=${searchFromSi}&searchToSi=${searchToSi}&searchLcKnd=${searchLcKnd}&searchMssage=${searchMssage}&searchSeriusLevel=${searchSeriusLevel}&searchSttus=${searchSttus}`);
}

// 장애관리 - 장애이력 목록 - 전체
export const getFHListAll = async (searchFcltyNo = null,
                                   searchFromDate,
                                   searchFromSi = '00',
                                   searchLcKnd = null,
                                   searchMssage = null,
                                   searchSeriusLevel = null,
                                   searchSttus = null,
                                   searchToDate,
                                   searchToSi = '23') => {

  return await apiClientGet(`api/v1/mgmtfult/histories-all?searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchFromSi=${searchFromSi}&searchLcKnd=${searchLcKnd}&searchMssage=${searchMssage}&searchSeriusLevel=${searchSeriusLevel}&searchSttus=${searchSttus}&searchToDate=${searchToDate}&searchToSi=${searchToSi}`);
  // return await apiClientGet(`api/v1/mgmtfult/histories-all?searchFromDate=2023-05-10&searchFromSi=00&searchLcKnd=${searchLcKnd}&searchToDate=2023-05-17&searchToSi=23`);
}

// 장애관리 - 장애이력 정보 조회
export const getFHInfo = async (rcptNo) => {
  return await apiClientGet(`api/v1/mgmtfult/histories/${rcptNo}`);
}

// 장애관리 - 장애이력 상태 변경
export const putFH = async (info) => {
  let uri = `api/v1/mgmtfult/histories/put/history`;
  let isFirst = true;

  /*Object.keys(info).map((key, value) => {
      //console.log(`${key} : ${stFacilityInfo[key]}`);
      if (key != 'atdrc_nm' &&
          key != 'cause_nm' &&
          key != 'lc_knd_nm' &&
          key != 'mssage' &&
          key != 'ocrn_dt_str' &&
          key != 'serius_level' &&
          key != 'serius_level_nm'
      ) {
          uri += urlAddParam(key, info[key], isFirst);
      }
      isFirst = false;
  });*/
  Object.keys(info).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, info[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri)
}

// 장애관리 - 장애현황 정보 조회
// userId 사용 안함
export const getFSInfo = async (causeId, lc) => {
  return await apiClientGet(`api/v1/mgmtfult/statuses/${causeId}/${lc}`);
}

export const putFS = async (info) => {
  let uri = `api/v1/mgmtfult/statuses/put/status`;
  let isFirst = true;

  Object.keys(info).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, info[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri)
}

// 성능관리 - 게이트웨이 목록
export const getPerfGWList = async (pageNum = 1,
                                    pageSize = 15,
                                    searchFcltyNo = null,
                                    searchFromDate,
                                    searchTerm = 'D',
                                    searchToDate) => {
  let uri = `api/v1/mgmtperf/device/gateways/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`;
  return await apiClientGet(uri);
}

// 성능관리 - 게이트웨이 목록 - 전체
export const getPerfGWListAll = async (pageNum = 1,
                                       pageSize = 15,
                                       searchFcltyNo = null,
                                       searchFromDate,
                                       searchTerm = 'D',
                                       searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/device/gateways-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}


// 성능관리 - 중계기 목록
export const getPerfRPTList = async (pageNum = 1,
                                     pageSize = 15,
                                     searchFcltyNo = null,
                                     searchFromDate,
                                     searchTerm = 'D',
                                     searchToDate
) => {
  return await apiClientGet(`api/v1/mgmtperf/device/repeaters/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}

// 성능관리 - 게이트웨이 목록 - 전체
export const getPerfRPTListAll = async (pageNum = 1,
                                        pageSize = 15,
                                        searchFcltyNo = null,
                                        searchFromDate,
                                        searchTerm = 'D',
                                        searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/device/repeaters-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}


// 성능관리 - 센서장비 목록
export const getPerfSSList = async (pageNum = 1,
                                    pageSize = 15,
                                    searchFcltyNo = null,
                                    searchFromDate,
                                    searchTerm = 'D',
                                    searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/device/sensors/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}

// 성능관리 - 센서장비 목록 - 전체
export const getPerfSSListAll = async (pageNum = 1,
                                       pageSize = 15,
                                       searchFcltyNo = null,
                                       searchFromDate,
                                       searchTerm = 'D',
                                       searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/device/sensors-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 종합
export const getPerfSysDailyList = async (pageNum = 1,
                                          pageSize = 15,
                                          searchFromDate,
                                          searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/daily/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 종합
export const getPerfSysDailyListAll = async (pageNum = 1,
                                             pageSize = 15,
                                             searchFromDate,
                                             searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/daily-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - CPU
export const getPerfSysCPUList = async (pageNum = 1,
                                        pageSize = 15,
                                        searchFromDate,
                                        searchRefValue = null,
                                        searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/cpus/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - CPU - 전체
export const getPerfSysCPUListAll = async (pageNum = 1,
                                           pageSize = 15,
                                           searchFromDate,
                                           searchRefValue = null,
                                           searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/cpus-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 메모리
export const getPerfSysMERList = async (pageNum = 1,
                                        pageSize = 15,
                                        searchFromDate,
                                        searchRefValue = null,
                                        searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/memories/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 메모리 - 전체
export const getPerfSysMERListAll = async (pageNum = 1,
                                           pageSize = 15,
                                           searchFromDate,
                                           searchRefValue = null,
                                           searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/memories-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 디스크
export const getPerfSysDISKList = async (pageNum = 1,
                                         pageSize = 15,
                                         searchFromDate,
                                         searchRefValue = null,
                                         searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/disks/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 디스크 - 전체
export const getPerfSysDISKListAll = async (pageNum = 1,
                                            pageSize = 15,
                                            searchFromDate,
                                            searchRefValue = null,
                                            searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/disks-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRefValue=${searchRefValue}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - 이더넷
export const getPerfSysETHList = async (pageNum = 1,
                                        pageSize = 15,
                                        searchFromDate,
                                        searchRxdrp = null,
                                        searchToDate,
                                        searchTxdrp = null) => {
  return await apiClientGet(`api/v1/mgmtperf/system/ethernets/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRxdrp=${searchRxdrp}&searchToDate=${searchToDate}&searchTxdrp=${searchTxdrp}`);
}

// 성능관리 - 시스템 - 이더넷 - 전체
export const getPerfSysETHListAll = async (pageNum = 1,
                                           pageSize = 15,
                                           searchFromDate,
                                           searchRxdrp = null,
                                           searchToDate,
                                           searchTxdrp = null) => {
  return await apiClientGet(`api/v1/mgmtperf/system/ethernets-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchRxdrp=${searchRxdrp}&searchToDate=${searchToDate}&searchTxdrp=${searchTxdrp}`);
}


// 성능관리 - 시스템 - DB
export const getPerfSysDBList = async (pageNum = 1,
                                       pageSize = 15,
                                       searchFromDate,
                                       searchStatsTy = null,
                                       searchTerm = 'H',
                                       searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/dbs/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchStatsTy=${searchStatsTy}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}

// 성능관리 - 시스템 - DB - 전체
export const getPerfSysDBListAll = async (pageNum = 1,
                                          pageSize = 15,
                                          searchFromDate,
                                          searchStatsTy = null,
                                          searchTerm = 'H',
                                          searchToDate) => {
  return await apiClientGet(`api/v1/mgmtperf/system/dbs-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchStatsTy=${searchStatsTy}&searchTerm=${searchTerm}&searchToDate=${searchToDate}`);
}


// 성능관리 - 브로커서버
export const getPerfBKList = async (pageNum = 1,
                                    pageSize = 15,
                                    searchFromDate,
                                    searchFromSi = null,
                                    searchTerm = 'H',
                                    searchToDate,
                                    searchToSi = null) => {
  return await apiClientGet(`api/v1/mgmtperf/device/brokers/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchFromSi=${searchFromSi}&searchTerm=${searchTerm}&searchToDate=${searchToDate}&searchToSi=${searchToSi}`);
}

// 성능관리 - 브로커서버 - 전체
export const getPerfBKListAll = async (pageNum = 1,
                                       pageSize = 15,
                                       searchFromDate,
                                       searchFromSi = null,
                                       searchTerm = 'H',
                                       searchToDate,
                                       searchToSi = null) => {
  return await apiClientGet(`api/v1/mgmtperf/device/brokers-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchFromSi=${searchFromSi}&searchTerm=${searchTerm}&searchToDate=${searchToDate}&searchToSi=${searchToSi}`);
}


// 트래픽관리 - 이상트래픽
export const getTrfATList = async (pageNum,
                                   pageSize,
                                   searchFcltyNo = null,
                                   searchFromDate,
                                   searchToDate) => {
  return await apiClientGet(`api/v1/mgmttrff/traffics/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}

// 트래픽관리 - 이상트래픽 - 전체
export const getTrfATListAll = async (searchFcltyNo = null,
                                      searchFromDate,
                                      searchToDate) => {
  return await apiClientGet(`api/v1/mgmttrff/traffics/status-all/?searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}

// 트래픽관리 - 송수신이력
export const getTrfHISList = async (pageNum, pageSize,
                                    searchFcltyNo,
                                    searchFromDate,
                                    searchFromSi = '00',
                                    searchFcltyDtlNo = null,
                                    searchSensorNm = null,
                                    searchToDate = null,
                                    searchToSi = '00',
                                    searchTopicNm = null) => {
  let uri = `api/v1/mgmttrff/histories/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchFromSi=${searchFromSi}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchSensorNm=${searchSensorNm}&searchToDate=${searchToDate}&searchToSi=${searchToSi}&searchTopicNm=${searchTopicNm}`
  return await apiClientGet(uri);
}

// 트래픽관리 - 송수신이력
export const getTrfHISListAll = async (pageNum, pageSize,
                                       searchFcltyNo,
                                       searchFromDate,
                                       searchFromSi = '00',
                                       searchFcltyDtlNo = null,
                                       searchSensorNm = null,
                                       searchToDate = null,
                                       searchToSi = '00',
                                       searchTopicNm = null) => {
  let uri = `api/v1/mgmttrff/histories-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}&searchFromDate=${searchFromDate}&searchFromSi=${searchFromSi}&searchFcltyDtlNo=${searchFcltyDtlNo}&searchSensorNm=${searchSensorNm}&searchToDate=${searchToDate}&searchToSi=${searchToSi}&searchTopicNm=${searchTopicNm}`
  return await apiClientGet(uri);
}

// 사용자관리 - 인증
export const getUserAUTHList = async (pageNum, pageSize, searchOgdpTy, searchUserId, searchUserNm) => {
  return await apiClientGet(`api/v1/mgmtuser/users/?pageNum=${pageNum}&pageSize=${pageSize}&searchOgdpTy=${searchOgdpTy}&searchUserId=${searchUserId}&searchUserNm=${searchUserNm}`);
}

// 사용자관리 - 인증 - 전체
export const getUserAUTHListAll = async (pageNum, pageSize, searchOgdpTy, searchUserId, searchUserNm) => {
  return await apiClientGet(`api/v1/mgmtuser/users-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchOgdpTy=${searchOgdpTy}&searchUserId=${searchUserId}&searchUserNm=${searchUserNm}`);
}

// 사용자관리 - 회원정보
export const getUserInfo = async (userId) => {
  return await apiClientGet(`api/v1/mgmtuser/users/${userId}`);
};

//api/v1/mgmtuser/users/post/user?userId=test2&password=test&userNm=test&userTelno=010-0000-0000&ogdpTy=1&userGrade=2&comment=test%20400
// 사용자관리 - 인증 - 회원정보 등록
export const postUserInfo = async (stUserInfo) => {
  let uri = `api/v1/mgmtuser/users/post/user`;
  let isFirst = true;

  Object.keys(stUserInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, stUserInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 사용자관리 - 인증 - 회원정보 수정
export const putUserInfo = async (stUserInfo) => {
  let uri = `api/v1/mgmtuser/users/put/user`;
  let isFirst = true;

  Object.keys(stUserInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, stUserInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 사용자관리 - 인증 목록 (전체)
export const getUserListAll = async () => {
  return await apiClientGet(`api/v1/mgmtuser/users-all`);
}

// 사용자관리 - 인증 - 아이디 중복체크
export const getUserDoubleCheck = async (userId) => {
  return await apiClientGet(`api/v1/mgmtuser/users/is-exist/${userId}`);
};

// 사용자관리 - 인증 - 삭제
export const delUserInfo = async (userId, comment) => {
  let uri = `api/v1/mgmtuser/users/delete/user?comment=${comment}&userId=${userId}`;

  console.log(uri);

  return await apiClientPost(uri)
}


// 사용자관리 - 인가
export const getUserACCRList = async () => {
  return await apiClientGet(`api/v1/mgmtuser/grades`);
}

// 사용자관리 - 인가 수정
export const regUserACCR = async (paramList) => {
  let uri = `api/v1/mgmtuser/grades/post/grade`;
  console.log("## uri :: ", uri);

  let data = {
    paramList: paramList
  };
  console.log("## data :: ", data);
  return await apiClientPostJsonData(uri, data);
}

// 사용자관리 - 토픽
export const getUserTOPList = async (pageNum, pageSize, searchMqttId, searchPrpos, searchSe) => {
  return await apiClientGet(`api/v1/mgmtuser/topics/?pageNum=${pageNum}&pageSize=${pageSize}&searchMqttId=${searchMqttId}&searchPrpos=${searchPrpos}&searchSe=${searchSe}`);
}

// 사용자관리 - 토픽 - 전체
export const getUserTOPListAll = async (pageNum, pageSize, searchMqttId, searchPrpos, searchSe) => {
  return await apiClientGet(`api/v1/mgmtuser/topics-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchMqttId=${searchMqttId}&searchPrpos=${searchPrpos}&searchSe=${searchSe}`);
}

// 사용자관리 - 토픽 아이디 중복체크
export const getMqttDoubleCheck = async (mqttId) => {
  return await apiClientGet(`api/v1/mgmtuser/topics/is-exist/${mqttId}`);
};

// 사용자관리 - 토픽 MQTT 계정관리 - 등록
/*export const regTopics = async (mqttId, password, prpos, se) => {
  return await apiClientPost(`api/v1/mgmtuser/topics/post/user?mqttId=${mqttId}&password=${password}&prpos=${prpos}&se=${se}`)
};*/
export const regTopics = async (mqttAcntInfo) => {
  let uri = `api/v1/mgmtuser/topics/post/user`;
  let isFirst = true;

  Object.keys(mqttAcntInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, mqttAcntInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 사용자관리 - 토픽 MQTT 계정관리 - 수정
export const putTopics = async (mqttAcntInfo) => {
  let uri = `api/v1/mgmtuser/topics/put/user`;
  let isFirst = true;

  Object.keys(mqttAcntInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, mqttAcntInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 사용자관리 - 토픽 MQTT 계정관리 - 삭제
export const delTopics = async (checkItems) => {
  let uri = `api/v1/mgmtuser/topics/delete-all/user`;

  /*  const tempArr = [];
    for (let i = 0; i < checkItems.length; i++) {
      const tempObj = {};
      tempObj.mqttId = checkItems[i];
      // const key = Object.keys(tempObj)[0];
      tempArr.push(['mqttId',tempObj.mqttId]);
    }

    console.log(tempArr);*/

  //return await apiClientPost(uri,`{"paramList": [{"mqttId": "${checkItems[0]}"}}]}`);
  let paramList = new Array();
  for (let i = 0; i < checkItems.length; i++) {
    // console.log("## checkItems[i] :: ", checkItems[i]);
    paramList.push({
      mqttId: checkItems
    });
  }

  let data = {
    paramList: paramList
  };
  // console.log("## data :: ", data);
  return await apiClientPostJsonData(uri, data);
};

/*// 시스템관리 - 펌웨어 - 삭제
export const delSysFw = async (mngNo) => {
  let uri = `api/v1/mgmtsysm/firmwares/delete-all/firmware`;

  return await apiClientPost(uri, `{"paramList": [{mngNo: ${mngNo}}]}`);
}*/


// 사용자관리 - 토픽 등록 - 리스트
export const getTopicsList = async (pageNum, pageSize,
                                    mqttId) => {
  return await apiClientGet(`api/v1/mgmtuser/topics/acls?mqttId=${mqttId}&pageNum=${pageNum}&pageSize=${pageSize}`)
};

// 사용자관리 - 토픽 등록 - 등록
export const postTopicReg = async (topicInfo) => {
  let uri = `api/v1/mgmtuser/topics/acls/post/topic`;
  let isFirst = true;

  Object.keys(topicInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, topicInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri);
}

// 사용자관리 - 토픽 수정
export const putTopic = async (topicInfo) => {
  let uri = `api/v1/mgmtuser/topics/acls/put/topic`;
  let isFirst = true;

  Object.keys(topicInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, topicInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri);
}

// 사용자관리 - 토픽 삭제
export const delTopic = async (mqttId, checkItems) => {
  let uri = `api/v1/mgmtuser/topics/acls/delete-all/topic`;

  console.log(checkItems)

  /*  const tempArr = [];
    for (let i = 0; i < checkItems.length; i++) {
      const tempObj = {};
      tempObj.mqttId = checkItems[i];
      // const key = Object.keys(tempObj)[0];
      tempArr.push(['mqttId',tempObj.mqttId]);
    }

    console.log(tempArr);*/

  //return await apiClientPost(uri,`{"paramList": [{"mqttId": "${checkItems[0]}"}}]}`);
  let paramList = new Array();
  for (let i = 0; i < checkItems.length; i++) {
    console.log("## checkItems[i] :: ", checkItems[i]);
    paramList.push({
      mqttId: mqttId,
      topic: checkItems[i],
    });
  }

  let data = {
    paramList: paramList
  };
  console.log("## data :: ", data);
  return await apiClientPostJsonData(uri, data);
}

// 사용자관리 - MQTT 계정관리 정보조회
export const getTopicsDetail = async (mqtt_id) => {
  return await apiClientGet(`api/v1/mgmtuser/topics/${mqtt_id}`);
}

// 사용자관리 - 접근권한이력
export const getUserAHList = async (pageNum, pageSize,
                                    searchFromDate,
                                    searchToDate,
                                    searchUserNm, searchWorkerId) => {
  let uri = `api/v1/mgmtuser/change-logs/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}&searchUserNm=${searchUserNm}&searchWorkerId=${searchWorkerId}`
  console.log(uri);
  return await apiClientGet(uri);
}

// 사용자관리 - 접근권한이력 - 전체
export const getUserAHListAll = async (pageNum, pageSize,
                                       searchFromDate,
                                       searchToDate,
                                       searchUserNm, searchWorkerId,
                                       searchOrderBy, searchOrderByDesc) => {
  return await apiClientGet(`api/v1/mgmtuser/change-logs-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchOrderBy=${searchOrderBy}&searchOrderByDesc=${searchOrderByDesc}&searchToDate=${searchToDate}&searchUserNm=${searchUserNm}&searchWorkerId=${searchWorkerId}`);
}

// 시스템관리 - SMS발송설정
export const getSysSETList = async (pageNum, pageSize,
                                    searchOgdpTy, searchOrderBy,
                                    searchOrderByDesc, searchUserId,
                                    searchUserNm) => {
  return await apiClientGet(`api/v1/mgmtsysm/sms/?pageNum=${pageNum}&pageSize=${pageSize}&searchOgdpTy=${searchOgdpTy}&searchOrderBy=${searchOrderBy}&searchOrderByDesc=${searchOrderByDesc}&searchUserId=${searchUserId}&searchUserNm=${searchUserNm}`);
}

// 시스템관리 - SMS발송설정 목록 (전체)
export const getSysSETListAll = async () => {
  return await apiClientGet(`api/v1/mgmtsysm/sms-all`);
}

// 시스템관리 - SMS발송설정 정보조회
// 수정받아야하는 API (user_list 정보 요청)
export const getSysSETDetail = async (group_id) => {
  return await apiClientGet(`api/v1/mgmtsysm/sms/${group_id}`);
}

// 시스템관리 - sms발송설정 등록
export const postSysSetDetail = async (smsInfo) => {
  let uri = `api/v1/mgmtsysm/sms/post/sms`;
  let isFirst = true;

  Object.keys(smsInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, smsInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 시스템관리 - sms 발송 설정 수정
export const putSysSetDetail = async (smsInfo) => {
  let uri = `api/v1/mgmtsysm/sms/put/sms`;
  let isFirst = true;

  Object.keys(smsInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, smsInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);

  return await apiClientPost(uri)
}

// 시스템관리 - sms 발송 설정 삭제
export const delSysSetDetail = async (group_id) => {
  let uri = `api/v1/mgmtsysm/sms/delete/sms?groupId=${group_id}`;

  console.log(uri);

  return await apiClientPost(uri)
}


// 시스템관리 - 펌웨어
export const getSysFWList = async (pageNum, pageSize,
                                   searchDeviceTy) => {
  return await apiClientGet(`api/v1/mgmtsysm/firmwares/?pageNum=${pageNum}&pageSize=${pageSize}&searchDeviceTy=${searchDeviceTy}`);
}

// 시스템관리 - 펌웨어 - 전체
export const getSysFWListAll = async (pageNum, pageSize,
                                      searchDeviceTy) => {
  return await apiClientGet(`api/v1/mgmtsysm/firmwares-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchDeviceTy=${searchDeviceTy}`);
}

// 시스템관리 - 펌웨어 - 등록
export const regSysFWList = async (firmwareInfo) => {
  const formData = new FormData();

  console.log(firmwareInfo)

  formData.append('deviceTy', firmwareInfo.device_ty);
  formData.append('fwFile', firmwareInfo.fw_file);
  formData.append('fwVer', firmwareInfo.fw_ver);
  formData.append('mkr', firmwareInfo.mkr);

  console.log(formData);

  return await apiClientPostFormData(`api/v1/mgmtsysm/firmwares/post/firmware`, formData);
};

// 시스템관리 - 펌웨어 - 삭제
export const delSysFw = async (mngNo) => {
  let uri = `api/v1/mgmtsysm/firmwares/delete-all/firmware`;
  let data = JSON.stringify({
    "paramList": [
      {
        "mngNo": mngNo
      }
    ]
  });

  var config = {
    method: 'post',
    url: `${SWAGGER_BASE_URL}api/v1/mgmtsysm/firmwares/delete-all/firmware`,
    headers: {
      "Authorization": `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`,
      'Content-Type': 'application/json'
    },
    data: data
  };

  //return await apiClientPost(uri, data);
  return await axios(config);
}


// 시스템관리 - SMS발송이력
export const getSysHISList = async (pageNum, pageSize,
                                    startDate,
                                    endDate,
                                    searchKeyword) => {
  let uri = `api/v1/mgmtsysm/history/sms/`;
  uri += `?pageNum=${pageNum}`
  uri += `&pageSize=${pageSize}`
  uri += `&searchFromDate=${startDate}`
  uri += `&searchToDate=${endDate}`
  uri += `&searchKeyword=${searchKeyword}`
  console.log("## getSysHISList :: ", uri);

  return await apiClientGet(uri);
}

// 시스템관리 - SMS발송이력 - 전체
export const getSysHISListAll = async (pageNum, pageSize,
                                       startDate,
                                       endDate) => {
  let uri = `api/v1/mgmtsysm/history/sms-all`;
  uri += `?searchFromDate=${startDate}`
  uri += `&searchToDate=${endDate}`

  return await apiClientGet(uri);
}

// 시스템관리 - 119신고이력
export const getSysREPHISList = async (pageNum, pageSize,
                                       startDate,
                                       endDate,
                                       searchFcltyNo) => {
  let uri = `api/v1/mgmtsysm/history/report/`;
  uri += `?pageNum=${pageNum}`
  uri += `&pageSize=${pageSize}`
  uri += `&searchFromDate=${startDate}`
  uri += `&searchToDate=${endDate}`
  uri += `&searchFcltyNo=${searchFcltyNo}`
  return await apiClientGet(uri);
}

// 시스템관리 - 119신고이력 - 전체
export const getSysREPHISListAll = async (pageNum, pageSize,
                                          startDate,
                                          endDate,
                                          searchKeyword) => {
  let uri = `api/v1/mgmtsysm/history/report-all/`;
  uri += `?pageNum=${pageNum}`
  uri += `&pageSize=${pageSize}`
  uri += `&searchFromDate=${startDate}`
  uri += `&searchToDate=${endDate}`
  uri += `&searchKeyword=${searchKeyword}`
  return await apiClientGet(uri);
}

// 시스템관리 - 화재안전관리자
export const getSysFcltyDeptList = async (pageNum, pageSize,
                                          searchFcltyNo) => {
  return await apiClientGet(`api/v1/mgmtsysm/managers/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}`);
}

// 시스템관리 - 화재안전관리자 - 전체
export const getSysFcltyDeptListAll = async (pageNum, pageSize,
                                             searchFcltyNo) => {
  return await apiClientGet(`api/v1/mgmtsysm/managers-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFcltyNo=${searchFcltyNo}`);
}

// 시스템관리 - 화재안전관리자 정보조회
export const getSysFcltyDeptDetail = async (pic_no) => {
  console.log(`api/v1/mgmtsysm/managers/${pic_no}`);
  return await apiClientGet(`api/v1/mgmtsysm/managers/${pic_no}`);
}

// 시스템관리 - 화재안전관리자 등록
export const postSysFcltyDeptDetail = async (fcltyDeptInfo) => {
  let uri = `api/v1/mgmtsysm/managers/post/manager`;
  let isFirst = true;

  Object.keys(fcltyDeptInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, fcltyDeptInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri)
}

// 시스템관리 - 화재안전관리자 수정
export const putSysFcltyDeptDetail = async (fcltyDeptInfo) => {
  let uri = `api/v1/mgmtsysm/managers/put/manager`;
  let isFirst = true;

  Object.keys(fcltyDeptInfo).map((key, value) => {
    //console.log(`${key} : ${stFacilityInfo[key]}`);
    uri += urlAddParam(key, fcltyDeptInfo[key], isFirst);
    isFirst = false
  })

  console.log(uri);
  return await apiClientPost(uri)
}

// 시스템관리 - 화재안전관리자 삭제
export const delSysFcltyDeptDetail = async (picNo) => {
  let uri = `api/v1/mgmtsysm/managers/delete/manager?picNo=${picNo}`;
  console.log(uri);
  return await apiClientPost(uri)
}

// 시스템관리 - 화재안전관리자 일괄 삭제
export const delAllSysFcltyDeptDetail = async (checkItems) => {
  let uri = `api/v1/mgmtsysm/managers/delete-all/manager`;

  let paramList = new Array();
  for (let i = 0; i < checkItems.length; i++) {
    // console.log("## checkItems[i] :: ", checkItems[i]);
    paramList.push({
      picNo: checkItems
    });
  }

  let data = {
    paramList: paramList
  };
  return await apiClientPostJsonData(uri, data);
}

// 시스템관리 - 보고서
export const getSysReport = async (pageNum, pageSize, searchFromDate, searchToDate) => {
  return await apiClientGet(`api/v1/mgmtsysm/reports/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}

// 시스템관리 - 보고서 - 전체
export const getSysReportAll = async (pageNum, pageSize, searchFromDate, searchToDate) => {
  return await apiClientGet(`api/v1/mgmtsysm/reports-all/?pageNum=${pageNum}&pageSize=${pageSize}&searchFromDate=${searchFromDate}&searchToDate=${searchToDate}`);
}


// 시스템관리 - 보고서 정보조회
export const getSysReportDetail = async (stdde) => {
  return await apiClientGet(`api/v1/mgmtsysm/reports/${stdde}`);
}

// 시스템관리 - 일일운영일지 - 자료 다운로드
export const getSysReportWord = async (stdde) => {
  return await apiClientGetFile(`api/v1/mgmtsysm/reports/word/${stdde}`);
}

// 시스템관리 - 일일운영일지 - 운영일지 다운로드
export const getSysOperationLogWord = async (stdde) => {
  return await apiClientGetFile(`api/v1/mgmtsysm/reports/working/${stdde}`);
}

// 시스템관리 - 일일운영일지 - 운영일지 업로드
export const postSysOperationLogWord = async (operationLogInfo) => {

  let uri = `api/v1/mgmtsysm/reports/put/report`;
  let formData = new FormData();

  formData.append('file', operationLogInfo.file);
  formData.append('stdde', operationLogInfo.stdde);

  return await apiClientPostFormData(uri, formData);
};

// 시스템관리 - 보고서 등록
export const regReport = async (reportRegInfo) => {
  // console.log(reportRegInfo);
  let uri = `api/v1/mgmtsysm/reports/post/report`;
  let isFirst = true;

  Object.keys(reportRegInfo).map((key, value) => {
    // console.log(`${key} : ${reportRegInfo[key]}`);
    uri += urlAddParam(key, reportRegInfo[key], isFirst);
    isFirst = false;
  });

  // console.log(uri);
  return await apiClientPost(uri);
}

// 시스템관리 - 보고서 수정
export const putReport = async (reportRegInfo) => {
  console.log(reportRegInfo);
  let uri = `api/v1/mgmtsysm/reports/put/report`;
  let isFirst = true;

  Object.keys(reportRegInfo).map((key, value) => {
    console.log(`${key} : ${reportRegInfo[key]}`);
    if (key === 'stdde_str') {
      console.log(key);
      const tempKey = 'stdde';
      console.log(tempKey);
      uri += urlAddParam(tempKey, reportRegInfo[key], isFirst);
    } else {
      uri += urlAddParam(key, reportRegInfo[key], isFirst);
    }
    isFirst = false;
  });

  console.log(uri);
  return await apiClientPost(uri);
}